// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Layout, { Container } from "../components/layout";
// import { apiurl } from "../config/config";
// import { getCookie } from "../config/webStorage";
// import moment from "moment";
// import { Link } from "react-router-dom";

// const Shipments = () => {
//   const [shipments, setShipments] = useState([]);
//   const [awbSearch, setAwbSearch] = useState("");
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     limit: 50,
//   });

//   const swtoken = getCookie("swtoken");

//   const fetchShipments = async (page = 1) => {
//     try {
//       const params = {
//         page,
//         limit: pagination.limit,
//         awb: awbSearch.trim(), // optional AWB filter
//       };

//       const { data } = await axios.get(
//         `${apiurl}/api/order/shiprocket/shipments`,
//         {
//           params,
//           headers: {
//             Authorization: swtoken,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setShipments(data.data || []);
//       setPagination((prev) => ({
//         ...prev,
//         currentPage: data.pagination?.currentPage || 1,
//         totalPages: data.pagination?.totalPages || 1,
//       }));
//     } catch (error) {
//       console.error("Error fetching shipments:", error);
//     }
//   };

//   useEffect(() => {
//     fetchShipments();
//   }, []);

//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-6">
//           <h2 className="text-2xl font-bold mb-4">Shiprocket Shipments</h2>

//           <div className="flex gap-4 mb-4 items-center">
//             <input
//               type="text"
//               placeholder="Search by AWB"
//               className="border p-2 rounded w-64"
//               value={awbSearch}
//               onChange={(e) => setAwbSearch(e.target.value)}
//             />
//             <button
//               className="bg-blue-600 text-white px-4 py-2 rounded"
//               onClick={() => fetchShipments(1)}
//             >
//               Search
//             </button>
//           </div>

//           <div className="overflow-auto">
//             <table className="min-w-full border">
//               <thead>
//                 <tr className="bg-gray-100 text-left">
//                   <th className="border px-4 py-2">AWB</th>
//                   <th className="border px-4 py-2">Order ID</th>
//                   <th className="border px-4 py-2">Status</th>
//                   <th className="border px-4 py-2">Courier</th>
//                   <th className="border px-4 py-2">Date</th>
//                   <th className="border px-4 py-2">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {shipments.length > 0 ? (
//                   shipments.map((shipment) => (
//                     <tr key={shipment._id}>
//                       <td className="border px-4 py-2">{shipment.awb || "-"}</td>
//                       <td className="border px-4 py-2">
//                         {shipment.order_id || "-"}
//                       </td>
//                       <td className="border px-4 py-2 capitalize">
//                         {shipment.shipment_status || "-"}
//                       </td>
//                       <td className="border px-4 py-2">
//                         {shipment.courier_name || "-"}
//                       </td>
//                       <td className="border px-4 py-2">
//                         {moment(shipment.createdAt).format("DD MMM YYYY")}
//                       </td>
//                         <td className="border px-4 py-2">
//                       <Link className=" px-4 py-2" to={`/sales/shipments/${shipment.awb}`}>
//                             View
//                       </Link>
//                         </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="5" className="text-center p-4">
//                       No shipments found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination Controls */}
//           <div className="flex justify-center mt-4 gap-2">
//             <button
//               disabled={pagination.currentPage === 1}
//               onClick={() => fetchShipments(pagination.currentPage - 1)}
//               className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <span className="px-4 py-2">
//               Page {pagination.currentPage} of {pagination.totalPages}
//             </span>
//             <button
//               disabled={pagination.currentPage === pagination.totalPages}
//               onClick={() => fetchShipments(pagination.currentPage + 1)}
//               className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default Shipments;

import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import moment from "moment";
  import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Shipments = () => {
  const [shipments, setShipments] = useState([]);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    status: "DELIVERED",
  });

  /* 🔥 FETCH NEW API */
  const fetchShipments = async () => {
    try {
      setLoading(true);

      const { data } = await axios.get(
        `${apiurl}/api/shipment/get`,
        {
          params: {
            startDate: filters.startDate,
            endDate: filters.endDate,
            status: filters.status,
          },
        }
      );

      setShipments(data.data || []);
      setReport(data.report || {});
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* 🔥 DEFAULT TODAY */
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];

    setFilters({
      startDate: today,
      endDate: today,
      status: "DELIVERED",
    });

    fetchShipments();
  }, []);




  const getCards = () => {
  if (!report) return [];

  const baseCards = [
    { title: "Total", value: report.total || 0 },
  ];

  /* 🔥 STATUS BASED CARDS */
  if (filters.status === "OUT_FOR_DELIVERY") {
    baseCards.push(
      { title: "FOFD", value: report.FOFD || 0 },
      { title: "ROFD", value: report.ROFD || 0 },
      { title: "Total OFD", value: report.totalOFD || 0 }
    );
  }

  if (filters.status === "DELIVERED") {
    baseCards.push(
      { title: "FAD", value: report.FAD || 0 },
      { title: "RAD", value: report.RAD || 0 }
    );
  }

  if (filters.status === "RTO") {
    baseCards.push(
      { title: "RTO", value: report.RTO || 0 }
    );
  }

  return baseCards;
};




const downloadReport = () => {
  if (!shipments || shipments.length === 0) return;

  /* 🔥 SUMMARY SHEET */
  const summaryData = [
    { Metric: "Total", Value: report?.total || 0 },
    { Metric: "FAD", Value: report?.FAD || 0 },
    { Metric: "RAD", Value: report?.RAD || 0 },
    { Metric: "FOFD", Value: report?.FOFD || 0 },
    { Metric: "ROFD", Value: report?.ROFD || 0 },
    { Metric: "Total OFD", Value: report?.totalOFD || 0 },
    { Metric: "RTO", Value: report?.RTO || 0 },
  ];

  /* 🔥 ATTEMPT BREAKDOWN */
  const attemptsData = Object.entries(report?.attempts || {}).map(
    ([key, val]) => ({
      Attempt: key,
      Count: val,
    })
  );

  /* 🔥 MAIN DATA */
  const shipmentData = shipments.map((s) => {
    const lastEvent = s.eventsInRange?.slice(-1)[0];
    const lastAttempt = s.attempts?.slice(-1)[0];

    return {
      AWB: s.awb,
      Source: s.source,
      Attempts: s.attemptCount,
      Final_Attempt_Status: lastAttempt?.status || "-",
      Last_Status: lastEvent?.status,
      Sub_Status: lastEvent?.subStatus,
      Date: lastEvent?.time
        ? moment(lastEvent.time).format("DD-MM-YYYY HH:mm")
        : "-",
    };
  });

  /* 🔥 CREATE WORKBOOK */
  const wb = XLSX.utils.book_new();

  const summarySheet = XLSX.utils.json_to_sheet(summaryData);
  const attemptsSheet = XLSX.utils.json_to_sheet(attemptsData);
  const dataSheet = XLSX.utils.json_to_sheet(shipmentData);

  XLSX.utils.book_append_sheet(wb, summarySheet, "Summary");
  XLSX.utils.book_append_sheet(wb, attemptsSheet, "Attempts");
  XLSX.utils.book_append_sheet(wb, dataSheet, "Shipments");

  /* 🔥 EXPORT */
  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(
    file,
    `Shipment_Report_${filters.status}_${filters.startDate}.xlsx`
  );
};

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 space-y-6">

          {/* 🔥 FILTERS */}
          <div className="flex flex-wrap gap-3 bg-white p-4 rounded-xl shadow">
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, startDate: e.target.value })
              }
              className="border p-2 rounded"
            />

            <input
              type="date"
              value={filters.endDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
              className="border p-2 rounded"
            />

            <select
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              className="border p-2 rounded"
            >
              <option value="DELIVERED">Delivered</option>
              <option value="OUT_FOR_DELIVERY">Out For Delivery</option>
              <option value="RTO">RTO</option>
            </select>

            <button
              onClick={fetchShipments}
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              Apply
            </button>

            <button
  onClick={downloadReport}
  className="bg-green-600 text-white px-4 py-2 rounded"
>
  Download Report
</button>
          </div>

          {/* 🔥 KPI CARDS */}
          {/* {report && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Card title="Total" value={report.total || 0} />
              <Card title="FAD" value={report.FAD || 0} />
              <Card title="RAD" value={report.RAD || 0} />
              <Card title="Total OFD" value={report.totalOFD || 0} />
            </div>
          )} */}

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
  {getCards().map((card, i) => (
    <Card key={i} title={card.title} value={card.value} />
  ))}
</div>

{report?.attempts && (
  <div>
    <h3 className="text-lg font-semibold mb-2">Attempt Distribution (%)</h3>

    <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
      {Object.entries(report.attempts).map(([key, val]) => {
        const percent = ((val / report.total) * 100).toFixed(1);

        return (
          <div
            key={key}
            className="bg-white p-3 rounded-xl shadow text-center"
          >
            <p className="text-xs text-gray-500">Attempt {key}</p>
            <h2 className="text-lg font-bold">{val}</h2>
            <p className="text-xs text-gray-400">{percent}%</p>
          </div>
        );
      })}
    </div>
  </div>
)}

          {/* 🔥 TABLE */}
          <div className="bg-white rounded-xl shadow overflow-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2">AWB</th>
                  <th className="p-2">Source</th>
                  <th className="p-2">Attempts</th>
                  <th className="p-2">Final Attempt</th>
                  <th className="p-2">Last Status</th>
                  <th className="p-2">Date</th>
                </tr>
              </thead>

              <tbody>
                {shipments.map((s, i) => {
                  const lastEvent =
                    s.eventsInRange[s.eventsInRange.length - 1];

                  const lastAttempt =
                    s.attempts[s.attempts.length - 1];

                  return (
                    <tr key={i} className="border-b">
                      <td className="p-2 font-medium">{s.awb}</td>

                      <td className="p-2 capitalize">{s.source}</td>

                      <td className="p-2 text-center font-bold">
                        {s.attemptCount}
                      </td>

                      <td className="p-2 text-center">
                        {lastAttempt?.status || "-"}
                      </td>

                      <td className="p-2">
                        {lastEvent?.status} ({lastEvent?.subStatus})
                      </td>

                      <td className="p-2">
                        {lastEvent?.time
                          ? moment(lastEvent.time).format("DD MMM HH:mm")
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {shipments.length === 0 && (
              <div className="p-4 text-center text-gray-500">
                No data found
              </div>
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

// /* 🔥 SIMPLE CARD */
// const Card = ({ title, value }) => (
//   <div className="bg-white p-4 rounded-xl shadow">
//     <p className="text-sm text-gray-500">{title}</p>
//     <h2 className="text-xl font-bold">{value}</h2>
//   </div>
// );

export default Shipments;

const Card = ({ title, value }) => {
  let color = "text-gray-800";

  if (title.includes("F")) color = "text-green-600";
  if (title.includes("R")) color = "text-red-600";

  return (
    <div className="bg-white p-4 rounded-xl shadow">
      <p className="text-sm text-gray-500">{title}</p>
      <h2 className={`text-xl font-bold ${color}`}>{value}</h2>
    </div>
  );
};